<template>
  <div class="fc-modal-wrap">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'custom',
  props: [],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.fc-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 2rem;
}
</style>
